import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {ObservableBackendService} from "./observableBackend.service";
import {MailTemplate} from "../domain/mailTemplate";
import {ActionTrigger} from "../domain/actionTrigger";

/**
 * .
 * Created by jlado on 13/9/16.
 */
@Injectable()
export class ActionTriggerService {

    constructor(private backendService: ObservableBackendService) {
    }

    /*Por ahora, las Acciones Disparadoras son estáticas: no hay ABM*/
    public getActionTriggers(): Observable<ActionTrigger[]> {
        return this.backendService.get("actionTriggers", null);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/actionTrigger.service.ts
 **/